import useTeams from '@hooks/useTeams';
import theme from '@modules/theme';
import { Dialog } from '@mui/material';
import { handleTeamMemberImport, TEAM_MEMBER_COLUMNS } from '@utils/import-utils';
import { CSVImporter } from 'csv-import-react';

export interface UserImport {
    firstName: string;
    lastName: string;
    weight: number;
    birthday: string;
    grade?: string;
    experience?: number;
    phone?: string;
    activeSince?: string;
    gender?: string;
}

export interface Data<T> {
    columns: { key: string; name: string }[];
    num_columns: number;
    num_rows: number;
    error: string | null | undefined;
    rows: { values: T; index: number }[];
}

interface Props {
    onClose: () => void;
    // showModal: boolean;
}

export default function ImportModal({ onClose }: Props) {
    const { selectedTeam, refreshMembers } = useTeams();
    return (
        <Dialog fullWidth maxWidth="lg" open={true} onClose={onClose}>
            <CSVImporter
                isModal={false}
                darkMode={true}
                // waitOnComplete
                primaryColor={theme.palette.primary.main}
                onComplete={(data: Data<UserImport>) => {
                    data.rows
                        .map(({ values }) => values)
                        .map(
                            async (data) =>
                                await handleTeamMemberImport(data, selectedTeam?.id as string).then(
                                    refreshMembers,
                                ),
                        );
                    onClose();
                }}
                template={{
                    columns: TEAM_MEMBER_COLUMNS,
                }}
            />
        </Dialog>
    );
}
